// extracted by mini-css-extract-plugin
export var borderRadius = "_d6-4";
export var large = "_d6-3";
export var logoContainer = "_d6-0";
export var nameLogo = "_d6-2";
export var small = "_d6-1";